import React, { useEffect, useState } from "react";



export const EmailMessage = ({ header, email }) => {

    const attachments = email.attachments

    const onClick = (attachment) => {
        let iframe = document.getElementById(`iframe-${email.id}`);
        iframe.removeAttribute('srcdoc');
        iframe.src = `data:application/pdf;base64,${attachment.content}`;
        //$(`a#email-${email.id}`).show();
    }

    return (
        <>
            <div className="email">
                <h2 className="mb-4">{header} {email.id}</h2>
                <div className="mb-3">
                    <span className="me-3"><strong>{gettext("To")}:</strong> </span>{email.to_emails}
                </div>
                <div className="mb-3">
                    <span className="me-3"><strong>{gettext("Subject")}:</strong></span> {email.subject}
                </div>
                {(attachments.length == 0) &&
                    <>
                        <div className="mb-3">
                            <span className="me-3"><strong>{gettext('Attachments')}:</strong></span>
                            {attachments.map(attachment => {
                                return <button className="btn attachment" onClick={() => onClick(attachment)}>{attachment.filename}</button>
                            })}
                        </div>
                    </>
                }
                <div className="mb-4"><hr /></div>
                {(email.body_html === "" || email.body_html === null) ?
                    <iframe id={`iframe-${email.id}`} srcDoc={`<pre>${email.body}</pre>`} style={{ width: "100%", height: "300px", border: 0 }}></iframe>
                    :
                    <iframe id={`iframe-${email.id}`} srcDoc={`${email.body_html}`} style={{ width: "100%", height: "300px", border: 0 }}></iframe>
                }
            </div>
        </>
    )

}